export const COMMUNITY_OUTREACH_TRANSLATION = 'community_outreach';
